<template>
  <div class="order-detail-page">
    <div class="breadcrumb flex-rowl">
      <div class="breadcrumb-icon"></div>
      <div class="breadcrumb-content flex-rowl">
        <div class="breadcrumb-content-item" @click="handleReturn">
          业务订单中心
        </div>
        <div class="breadcrumb-content-arr"><van-icon name="arrow" /></div>
        <div class="breadcrumb-content-item">{{ detail.order_id }}</div>
      </div>
    </div>

    <!-- 加载提示 -->
    <div class="common-loading-wrap flex-rowc" v-if="isLoading">
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>

    <div class="main-wrap" v-else ref="mainWrap">
      <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
        <div class="common-list-item">
          <div class="order-info-wrap flex-rowl">
            <div class="order-icon"></div>
            <div class="order-content">
              <p>{{ detail.servicecontstr }}</p>
              <p class="flex-rowl">
                {{ detail.order_id }}
                <span
                  class="copy-icon"
                  :data-clipboard-text="detail.order_id"
                  @click.capture="handleCopyBtn(detail.order_id)"
                ></span>
              </p>
              <p class="txt">{{ formatTime(detail.create_time) }}</p>
              <div class="label">
                <a :href="`tel:${detail.createmobile}`">联系订单创建人</a>
              </div>
            </div>
          </div>
          <div
            class="user-info-wrap"
            v-if="detail.park_catering_service_order_obj"
          >
            <div class="name flex-rowl">
              对象：{{
                detail.park_catering_service_order_obj
                  ? detail.park_catering_service_order_obj.truename
                  : ""
              }}<a
                :href="`tel:${
                  detail.park_catering_service_order_obj &&
                  detail.park_catering_service_order_obj.mobile
                    ? detail.park_catering_service_order_obj.mobile
                    : ''
                }`"
                class="tel-icon"
              ></a>
            </div>
            <div class="label flex-rowl">
              <p v-if="detail.park_catering_service_order_obj.age">
                #{{ detail.park_catering_service_order_obj.age }}岁
              </p>
              <p>
                #{{
                  detail.park_catering_service_order_obj.isself == 1
                    ? "有独立行动能力"
                    : "无独立行动能力"
                }}
              </p>
              <p v-if="detail.park_catering_service_order_obj.levelfloor">
                #{{ detail.park_catering_service_order_obj.levelfloor }}楼
              </p>
              <p v-if="detail.park_catering_service_order_obj.isElevatorstr">
                #{{ detail.park_catering_service_order_obj.isElevatorstr }}
              </p>
            </div>
            <div class="info" v-if="false">
              <p>
                身高：{{ detail.park_catering_service_order_obj.height }}（cm）
              </p>
              <p>
                体重：{{ detail.park_catering_service_order_obj.weight }}（kg）
              </p>
              <p>
                血型：{{ detail.park_catering_service_order_obj.bloodtype }}
              </p>
            </div>
            <div class="medical-list" v-if="false">
              <div class="medical-item">
                <p>是否有常见病史？</p>
                <p>
                  <span
                    v-for="(item, index) in detail
                      .park_catering_service_order_obj.caseids_commonlist"
                    :key="index"
                    >{{ item.casename }}
                  </span>
                </p>
              </div>
              <div class="medical-item">
                <p>是否有慢性病史？</p>
                <p>
                  <span
                    v-for="(item, index) in detail
                      .park_catering_service_order_obj.caseids_slowlist"
                    :key="index"
                    >{{ item.casename }}
                  </span>
                </p>
              </div>
            </div>
            <div class="txt" v-if="false">
              <p>
                <span v-if="detail.province2str"
                  >{{ detail.province2str ? detail.province2str : "" }}，</span
                ><span v-if="detail.city2str"
                  >{{ detail.city2str ? detail.city2str : "" }}，</span
                ><span v-if="detail.area2str">{{
                  detail.area2str ? detail.area2str : ""
                }}</span>
              </p>
              <p>{{ detail.addr2 }}</p>
            </div>

            <div class="state">
              <p>
                状态：<span class="blue">{{
                  detail.service_order_statusstr
                }}</span>
                <span v-if="detail.service_order_status == 6" class="blue">{{
                  detail.service_rating == 1
                    ? "不满意"
                    : detail.service_rating == 2
                    ? "满意"
                    : detail.service_rating == 3
                    ? "非常满意"
                    : ""
                }}</span>
                <span
                  class="management-btn"
                  v-if="detail.service_order_status == 7"
                  @click.stop="handleShowManagePopup(1)"
                  >管理</span
                >
              </p>
              <div class="state-block flex-rowl">
                <p>分配：</p>
                <div class="content">
                  <p>
                    <span>{{
                      detail.totype == 1
                        ? "派单给陪护服务合作机构"
                        : detail.totype == 2
                        ? "派单给小铃铛陪护员"
                        : "待分配业务人员"
                    }}</span>
                  </p>
                  <div class="content-list" v-if="isDispatch">
                    <p
                      v-for="(itemChild, indexChild) in tempDispatchList"
                      :key="indexChild"
                      class="flex-rowl"
                    >
                      {{
                        detail.totype == 1
                          ? itemChild.insname
                          : detail.totype == 2
                          ? itemChild.get_staff_name
                          : ""
                      }}
                      <a
                        :href="`tel:${
                          detail.totype == 1
                            ? itemChild.mobile
                            : detail.totype == 2
                            ? itemChild.get_staff_contact
                            : ''
                        }`"
                        class="tel-icon"
                      ></a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="price-block">
              <div class="price-wrap">
                <p>
                  基础费用：<span :class="{ red: !detail.timeoutprice }">{{
                    detail.timeoutprice ? "¥" + detail.timeoutprice : "待核算"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: detail.isreturn != 2 }"
                    v-if="detail.isreturn == 1"
                    >{{
                      detail.returncheck == 1
                        ? "已退款"
                        : detail.returncheck == 2
                        ? "退款，不同意"
                        : "退款中"
                    }}</span
                  >
                  <span :class="{ red: detail.ispay != 1 }" v-else>{{
                    detail.ispaystr ? detail.ispaystr : "待支付"
                  }}</span>
                  <span
                    class="management-btn"
                    v-if="
                      detail.service_order_status == 8 &&
                      detail.ispay == 1 &&
                      detail.isreturn != 1
                    "
                    @click.stop="handleShowManagePopup(2)"
                    >管理</span
                  >
                </p>
                <p>
                  支付方式：<span>{{
                    detail.ispaystr
                      ? detail.paytype == 1
                        ? detail.paytypestr
                        : detail.paytypestr +
                          "，" +
                          (detail.getmancardno ? "已确认" : "待确认")
                      : ""
                  }}</span>
                </p>
              </div>
              <!-- 超时收费 -->
              <div class="price-wrap">
                <p>
                  超时费用：<span :class="{ red: !timeoutChargeObj.fee }">{{
                    timeoutChargeObj.fee ? "¥" + timeoutChargeObj.fee : "无"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: timeoutChargeObj.paystate != 1 }"
                    >{{
                      timeoutChargeObj.paystate == 1
                        ? "已支付"
                        : timeoutChargeObj.paystate == 2
                        ? "待支付"
                        : "无"
                    }}</span
                  >
                </p>
                <p>
                  支付方式：<span v-if="timeoutChargeObj.paytype">{{
                    timeoutChargeObj.paytype == 1
                      ? "线上支付"
                      : "线下现金结算" +
                        "，" +
                        (timeoutChargeObj.hrcode ? "已确认" : "待确认")
                  }}</span
                  ><span class="red" v-else>无</span>
                </p>
              </div>
              <!-- 额外交通费用 -->
              <div class="price-wrap">
                <p>
                  额外交通费用：<span :class="{ red: !extraChargeObj.fee }">{{
                    extraChargeObj.fee ? "¥" + extraChargeObj.fee : "无"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: extraChargeObj.paystate != 1 }"
                    >{{
                      extraChargeObj.paystate == 1
                        ? "已支付"
                        : extraChargeObj.paystate == 2
                        ? "待支付"
                        : "无"
                    }}</span
                  >
                </p>
                <p>
                  支付方式：<span v-if="extraChargeObj.paytype">{{
                    extraChargeObj.paytype == 1
                      ? "线上支付"
                      : "线下现金结算" +
                        "，" +
                        (extraChargeObj.hrcode ? "已确认" : "待确认")
                  }}</span
                  ><span class="red" v-else>无</span>
                </p>
              </div>
              <!-- 其他额外费用 -->
              <div class="price-wrap">
                <p>
                  其他额外费用：<span
                    :class="{ red: !otherExtraChargeObj.id }"
                    >{{
                      otherExtraChargeObj.id
                        ? "¥" + otherExtraChargeObj.fee
                        : "无"
                    }}</span
                  >
                  <span v-if="otherExtraChargeObj.feetype">{{
                    otherExtraChargeObj.feetype == 1
                      ? "药品购买费用"
                      : otherExtraChargeObj.feetype == 2
                      ? "挂号费"
                      : otherExtraChargeObj.feetype == 3
                      ? "检查预约付费"
                      : otherExtraChargeObj.feetype == 4
                      ? "住院押金"
                      : "其它额外费用"
                  }}</span>
                </p>
                <p>
                  支付状态：<span
                    :class="{ red: otherExtraChargeObj.paystate != 1 }"
                    >{{
                      otherExtraChargeObj.paystate == 1
                        ? "已支付"
                        : otherExtraChargeObj.paystate == 2
                        ? "待支付"
                        : "无"
                    }}</span
                  >
                </p>
                <p>
                  支付方式：<span v-if="otherExtraChargeObj.paytype">{{
                    otherExtraChargeObj.paytype == 1
                      ? "线上支付"
                      : "线下现金结算" +
                        "，" +
                        (otherExtraChargeObj.hrcode ? "已确认" : "待确认")
                  }}</span
                  ><span class="red" v-else>无</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 其它费用管理 -->
        <div class="common-card-list">
          <!-- 额外费用 -->
          <div
            class="common-card-item extra-card-item flex-between"
            v-if="timeoutChargeObj.id"
          >
            <div class="content">
              <div class="title">
                <h1>待审核的追加收费项</h1>
                <p>服务超时追加费用</p>
              </div>
              <div class="price-state-wrap flex-rowl">
                <div class="price">
                  <span>¥</span>{{ timeoutChargeObj.fee }}
                </div>
                <div class="state">
                  {{
                    timeoutChargeObj.checkstate == 1
                      ? "审核通过"
                      : timeoutChargeObj.checkstate == 2
                      ? "审核未通过"
                      : "审核中"
                  }}
                </div>
              </div>
              <div
                class="btn flex-rowc"
                :class="{ disabled: timeoutChargeObj.checkstate == 1 }"
                @click="showExtraChargePopup(1, timeoutChargeObj)"
              >
                管理
              </div>
            </div>
          </div>

          <!-- 额外交通费用 -->
          <div
            class="common-card-item extra-card-item flex-between"
            v-if="extraChargeObj.id"
          >
            <div class="content">
              <div class="title">
                <h1>待审核的额外交通费用项</h1>
                <p>额外交通费用</p>
              </div>
              <div class="price-state-wrap flex-rowl">
                <div class="price"><span>¥</span>{{ extraChargeObj.fee }}</div>
                <div class="state">
                  {{
                    extraChargeObj.checkstate == 1
                      ? "审核通过"
                      : extraChargeObj.checkstate == 2
                      ? "审核未通过"
                      : "审核中"
                  }}
                </div>
              </div>
              <div
                class="btn flex-rowc"
                :class="{ disabled: extraChargeObj.checkstate == 1 }"
                @click="showExtraChargePopup(2, extraChargeObj)"
              >
                管理
              </div>
            </div>
          </div>
          <!-- 其他额外费用 -->
          <div
            class="common-card-item extra-card-item flex-between"
            v-if="otherExtraChargeObj.id"
          >
            <div class="content">
              <div class="title">
                <h1>
                  待审核的{{
                    otherExtraChargeObj.feetype == 1
                      ? "药品购买费用"
                      : otherExtraChargeObj.feetype == 2
                      ? "挂号费"
                      : otherExtraChargeObj.feetype == 3
                      ? "检查预约付费"
                      : otherExtraChargeObj.feetype == 4
                      ? "住院押金"
                      : "其它额外费用"
                  }}
                </h1>
                <p>
                  {{
                    otherExtraChargeObj.feetype == 1
                      ? "药品购买费用"
                      : otherExtraChargeObj.feetype == 2
                      ? "挂号费"
                      : otherExtraChargeObj.feetype == 3
                      ? "检查预约付费"
                      : otherExtraChargeObj.feetype == 4
                      ? "住院押金"
                      : "其它额外费用"
                  }}
                </p>
              </div>
              <div class="price-state-wrap flex-rowl">
                <div class="price">
                  <span>¥</span>{{ otherExtraChargeObj.fee }}
                </div>
                <div class="state">
                  {{
                    otherExtraChargeObj.checkstate == 1
                      ? "审核通过"
                      : otherExtraChargeObj.checkstate == 2
                      ? "审核未通过"
                      : "审核中"
                  }}
                </div>
              </div>

              <div
                class="btn flex-rowc"
                :class="{ disabled: otherExtraChargeObj.checkstate == 1 }"
                @click="showExtraChargePopup(3, otherExtraChargeObj)"
              >
                管理
              </div>
            </div>
          </div>
        </div>
        <div class="common-card-list">
          <div class="common-card-item flex-between">
            <div class="content">
              <p>{{ detail.isgetsendstr }}</p>
              <p class="txt" v-if="detail.isgetsend == 1">
                {{ detail.province2str }} {{ detail.city2str }}
                {{ detail.area2str }}
              </p>
              <p class="txt" v-if="detail.isgetsend == 1">
                {{ detail.addr2 }}
              </p>
            </div>
            <div
              class="edit-btn"
              @click="showCustomPopup('bottom', 2)"
              v-if="!isDispatch"
            >
              修改
            </div>
          </div>
          <div class="common-card-item flex-between" v-if="detail.servicecont != 17 && detail.servicecont != 21 && detail.servicecont != 22  && detail.servicecont != 23 && detail.servicecont != 24 && detail.servicecont != 25">
            <div class="content">
              <p>服务地点</p>
              <p class="txt">{{ detail.needinaddr }}</p>
              <p class="txt">
                {{ detail.provincestr }} {{ detail.citystr }}
                {{ detail.areastr }}
              </p>
              <p class="txt">
                {{ detail.addr }}
              </p>
            </div>
            <div
              class="edit-btn"
              @click="showCustomPopup('bottom', 3)"
              v-if="!isDispatch"
            >
              修改
            </div>
          </div>
          <div
            class="common-card-item flex-between"
            @click="handleShowPopup(1)"
          >
            <div class="content">
              <p>选择需要的附加器具</p>
              <p
                class="txt"
                :class="{ red: meachinestatestr != '(如需要请选择)' }"
              >
                {{ meachinestatestr }}
              </p>
            </div>
            <div class="select-arr" v-if="!isDispatch"></div>
          </div>
          <div
            class="common-card-item flex-between"
            @click="handleShowPopup(7)"
          >
            <div class="content">
              <p>服务人员数量</p>
              <p class="txt" :class="{ red: formData.mannum }">
                {{ !formData.mannum ? "(请选择)" : formData.mannum + "人" }}
              </p>
            </div>
            <div class="select-arr" v-if="!isDispatch"></div>
          </div>
          <div
            class="common-card-item flex-between"
            @click="handleShowPopup(2)"
            v-if="detail.gettype != 2"
          >
            <div class="content">
              <p>请选择服务时长</p>
              <p class="txt" :class="{ red: detail.duration }">
                {{
                  detail.duration ? detail.duration + "小时" : "(最低为1小时)"
                }}
              </p>
            </div>
            <div class="select-arr" v-if="!isDispatch"></div>
          </div>
          <div
            class="common-card-item flex-between"
            @click="handleShowPopup(3)"
          >
            <div class="content">
              <p>是否需要安全意外险</p>
              <p class="txt" :class="{ red: detail.isinsurance }">
                {{
                  detail.isinsurance
                    ? detail.isinsurance == 1
                      ? "需要"
                      : "不需要"
                    : "(如需要请选择)"
                }}
              </p>
            </div>
            <div class="select-arr" v-if="!isDispatch"></div>
          </div>
          <div class="common-card-item flex-between">
            <div class="content">
              <p>派单类型</p>
              <van-radio-group
                v-model="formData.totype"
                class="radio-group"
                @change="handleDispatchTypeChange"
                :disabled="isDispatch"
              >
                <van-radio name="1">派单给陪护服务合作机构</van-radio>
                <van-radio name="2">派单给小铃铛陪护员</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div class="user-wrap" v-if="formData.totype == 2">
          <div class="user-list">
            <div
              class="user-item flex-rowl"
              v-for="(item, index) in tempDispatchList"
              :key="index"
            >
              <div class="media" v-if="item.user">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="
                    item.user.headimg
                      ? item.user.headimg
                      : require('../../../assets/images/default_avatar.jpg')
                  "
                />
              </div>
              <div class="content flex-colc" v-if="item.user">
                <div class="name">
                  {{
                    item.get_staff_name
                      ? item.get_staff_name
                      : item.user.truename
                  }}
                </div>
                <div class="txt">
                  <p>{{ item.user.sex }}</p>
                  <p class="flex-rowl">
                    {{
                      item.employee_mobile
                        ? item.employee_mobile
                        : item.get_staff_contact
                    }}
                    <a
                      :href="`tel:${
                        item.employee_mobile
                          ? item.employee_mobile
                          : item.get_staff_contact
                      }`"
                      class="tel-icon"
                    ></a>
                  </p>
                  <!-- <p>好评率 98%</p> -->
                </div>
                <div
                  class="del flex-rowr"
                  @click="handleDel(item)"
                  v-if="!isDispatch"
                >
                  删除
                </div>
                <!-- <div class="tag flex-rowc"><span class="icon"></span>1级护理资质</div> -->
              </div>
            </div>
            <div
              class="user-item no flex-rowl"
              @click="showCustomPopup('bottom', 1)"
              v-if="!isDispatch"
            >
              <div class="media">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="require('../../../assets/images/default_avatar.png')"
                />
              </div>
              <div class="content flex-colc">
                <p>+选择追加的服务人员</p>
              </div>
            </div>
          </div>
        </div>
        <div class="user-wrap" v-if="formData.totype == 1">
          <div class="user-list">
            <div
              class="user-item flex-rowl"
              v-for="(item, index) in tempDispatchList"
              :key="index"
            >
              <div class="media">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="
                    item.logo
                      ? item.logo
                      : require('../../../assets/images/default_avatar.jpg')
                  "
                >
                  <template v-slot:error>
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="
                        require('../../../assets/images/default_avatar.jpg')
                      "
                    ></van-image>
                  </template>
                </van-image>
              </div>
              <div class="content flex-colc">
                <div class="name">
                  {{ item.insname }}
                </div>
                <div class="txt">
                  <p class="flex-rowl">
                    {{ item.tel }}
                    <a :href="`tel:${item.tel}`" class="tel-icon"></a>
                  </p>
                  <!-- <p>好评率 98%</p> -->
                </div>
                <div
                  class="del flex-rowr"
                  @click="handleDel(item)"
                  v-if="!isDispatch"
                >
                  删除
                </div>
                <!-- <div class="tag flex-rowc"><span class="icon"></span>1级护理资质</div> -->
              </div>
            </div>
            <div
              class="user-item no flex-rowl"
              @click="showCustomPopup('bottom', 4)"
              v-if="!isDispatch && tempDispatchList.length < 1"
            >
              <div class="media">
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="require('../../../assets/images/default_avatar.png')"
                />
              </div>
              <div class="content flex-colc">
                <p>+选择服务合作机构</p>
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <div class="bottom-wrap flex-rowc">
      <div class="bottom-wrap-return flex-rowc" @click="handleReturn">
        <span class="icon"></span> 返回
      </div>
      <div
        class="bottom-wrap-btn flex-rowc"
        :class="{ disabled: isSubmitting }"
        @click="handleSubmit"
        v-if="!isDispatch"
      >
        确认派单
      </div>
      <div
        class="bottom-wrap-btn flex-rowc"
        @click="previewImage(0, [detail.order_ercode])"
        v-if="
          detail.service_order_status == 2 || detail.service_order_status == 4
        "
      >
        业务码
      </div>
    </div>

    <van-popup v-model="isShow" position="bottom">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择附加器具"
          show-toolbar
          :columns="columnMeachine"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
      <template v-if="popupType == 2">
        <van-picker
          title="请选择服务时长"
          show-toolbar
          :columns="columnDuration"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
      <template v-if="popupType == 3">
        <van-picker
          title="请选择是否需要安全意外险"
          show-toolbar
          :columns="columnInsurance"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
      <template v-if="popupType == 4">
        <van-picker
          title="请选择省/直辖市"
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
      <template v-if="popupType == 5">
        <van-picker
          title="请选择城市"
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
      <template v-if="popupType == 6">
        <van-picker
          title="请选择区域"
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
      <template v-if="popupType == 7">
        <van-picker
          title="请选择服务人员数量"
          show-toolbar
          :columns="columnNum"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </template>
    </van-popup>

    <CustomPopup
      :visible="isShowCustomPopup"
      :position="popupPosition"
      @close="closeCustomPopup"
    >
      <!-- 陪护人员 -->
      <div class="custom-popup-content" v-if="displayModule == 1">
        <div class="search-wrap flex-rowl">
          <span class="search-icon" @click="handleSearch"
            ><img src="../../../assets/images/search-icon.png" alt=""
          /></span>
          <input
            type="text"
            placeholder="请输入关键词"
            v-model="dispatchParams.keyword"
            @keyup.enter="handleSearch"
          />
        </div>
        <div class="common-list-wrap">
          <div
            class="common-list"
            ref="UserList"
            @scroll="handleScroll"
            v-if="dispatchList.length > 0 && !isDispatchLoading"
          >
            <div
              class="common-item flex-rowl"
              v-for="(item, index) in dispatchList"
              :key="index"
              @click="handleSelect(item)"
            >
              <div class="media">
                <span
                  class="radio flex-rowc"
                  :class="{ active: item.is_selected }"
                ></span>
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="
                    item.user && item.user.headimg
                      ? item.user.headimg
                      : require('../../../assets/images/default_avatar.jpg')
                  "
                >
                  <template v-slot:error>
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="
                        require('../../../assets/images/default_avatar.jpg')
                      "
                    ></van-image>
                  </template>
                </van-image>
              </div>
              <div class="content">
                <div class="name">
                  {{ item.truename ? item.truename : item.user.nickname }}
                </div>
                <div class="txt">
                  <p>{{ item.user.sex }}</p>
                  <p class="flex-rowl">
                    {{ item.employee_mobile }}
                    <a
                      :href="`tel:${item.employee_mobile}`"
                      class="tel-icon"
                    ></a>
                  </p>

                  <!-- <p>{{ item.user.sex }}，{{ item.user.age }}岁</p> -->
                  <!-- <p>好评率 98%</p> -->
                </div>
                <!-- <div class="tag flex-rowc">
                <span class="icon"></span>1级护理资质
              </div> -->
              </div>
            </div>
          </div>
          <!-- 加载提示 -->
          <div class="common-loading-wrap flex-rowc" v-if="isDispatchLoading">
            <van-loading type="spinner" vertical>加载中...</van-loading>
          </div>
          <div
            class="common-no-data flex-rowc"
            v-if="dispatchList.length == 0 && !isDispatchLoading"
          >
            <van-empty description="暂无数据" />
          </div>
        </div>

        <div
          class="popup-btn-wrap flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleConfirm"
        >
          确认
        </div>
      </div>
      <!-- 选择上门服务 -->
      <div class="service-popup-content" v-if="displayModule == 2">
        <!-- 默认内容 -->
        <div class="select-wrap" v-if="!isAddAddress">
          <div
            class="select-item flex-rowl"
            :class="{ active: serviceFormData.isgetsend == 0 }"
            @click="handleSelectSend(0)"
            v-if="detail.servicecont != 17 && detail.servicecont != 21 && detail.servicecont != 22  && detail.servicecont != 23 && detail.servicecont != 24 && detail.servicecont != 25"
          >
            <span></span>
            <p>在服务地点接我</p>
          </div>
          <div
            class="select-item flex-rowl"
            :class="{ active: serviceFormData.isgetsend == 1 }"
            @click="handleSelectSend(1)"
          >
            <span></span>
            <p>我需要上门接送</p>
          </div>
        </div>
        <div class="default-content" v-if="!isAddAddress">
          <div class="title flex-between">
            <p>用户常用地址记录：</p>
            <div class="add-btn" @click="addServiceAddress">新增地址</div>
          </div>
          <div class="common-list-wrap">
            <div
              class="common-list"
              v-if="addressList.length > 0 && !addressLoading"
            >
              <div
                class="common-item flex-rowl"
                v-for="(item, index) in addressList"
                :key="index"
                @click="handleSelectAddress(item)"
                :class="{ active: item.is_selected }"
              >
                <div class="address--bule-icon"></div>
                <div class="item-info-content">
                  <div class="item-info-name">
                    {{ item.provincestr }} {{ item.citystr }} {{ item.areastr }}
                  </div>
                  <div class="item-info-text">{{ item.addr }}</div>
                  <div class="item-info-text flex-rowl">
                    <div class="item-info-value">
                      楼层：{{ item.levelfloor }}
                    </div>
                    <div class="item-info-value">
                      {{ item.isElevator == 1 ? "有电梯" : "无电梯" }}
                    </div>
                  </div>
                  <div class="item-info-operation flex-rowr">
                    <div class="operation-btn">选用</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 加载提示 -->
            <div class="common-loading-wrap flex-rowc" v-if="addressLoading">
              <van-loading type="spinner" vertical>加载中...</van-loading>
            </div>
            <div
              class="common-no-data flex-rowc"
              v-if="addressList.length == 0 && !addressLoading"
            >
              <van-empty description="暂无数据" />
            </div>
          </div>
          <div
            class="popup-btn-wrap flex-rowc"
            :class="{ disabled: isSubmitting }"
            @click="handleSubmitGetsend"
          >
            确认
          </div>
        </div>
        <!-- 新增服务用户地址 -->
        <div class="add-content" v-else>
          <div class="from-wrap flex-colc">
            <div class="from-wrap-input flex-between">
              <input
                type="text"
                placeholder="请输入地址名称"
                v-model="addressParams.topic"
              />
            </div>
            <div
              class="from-wrap-select flex-between"
              @click="handleShowAddressPopup(6)"
            >
              <input
                placeholder="请选择区域"
                :disabled="true"
                v-model="areaname"
              />
              <van-icon name="arrow-down" />
            </div>

            <div class="from-wrap-textarea flex-between">
              <textarea
                type="text"
                placeholder="请输入详细地址"
                v-model="addressParams.addr"
              />
            </div>

            <div class="from-wrap-input flex-between">
              <input
                type="number"
                placeholder="请输入楼层"
                v-model="addressParams.levelfloor"
              />
            </div>
            <div class="from-wrap-radio">
              <div class="label flex-rowl">
                <span class="required">*</span>所住楼栋是否有电梯？
              </div>
              <div class="form-radio flex-rowc">
                <div
                  v-for="(item, index) in elevatorList"
                  :key="index"
                  class="form-radio-item flex-rowl mb_30"
                  :class="{ active: addressParams.isElevator == item.value }"
                  @click="handleChangeRadio(item)"
                >
                  <van-icon name="passed" class="icon" />
                  {{ item.text }}
                </div>
              </div>
            </div>

            <div
              class="popup-btn-wrap flex-rowc"
              :class="{ disabled: isSubmitting }"
              @click="handleSubmitAddress"
            >
              确认
            </div>
          </div>
        </div>
      </div>
      <!-- 服务地点 -->
      <div class="location-popup-content" v-if="displayModule == 3">
        <div class="title flex-between">
          <p>选择常用服务地点：</p>
          <div class="add-btn" @click="handleAddServiceOrgan">新建服务地点</div>
        </div>
        <div class="search-wrap flex-rowl">
          <span class="search-icon" @click="handleSearch"
            ><img src="../../../assets/images/search-icon.png" alt=""
          /></span>
          <input
            type="text"
            placeholder="请输入关键词查找服务"
            v-model="serviceObjectOrgan.keyword"
            @keyup.enter="handleSearch"
          />
        </div>
        <div class="screen-wrap flex-between">
          <div class="screen-item flex-rowc" @click="handleShowAddressPopup(4)">
            <p>
              {{
                serviceObjectOrganProvincename
                  ? serviceObjectOrganProvincename
                  : "省/直辖市"
              }}
            </p>
            <van-icon name="arrow-down" />
          </div>
          <div class="screen-item flex-rowc" @click="handleShowAddressPopup(5)">
            <p>
              {{
                serviceObjectOrganCityname ? serviceObjectOrganCityname : "城市"
              }}
            </p>
            <van-icon name="arrow-down" />
          </div>
          <div class="screen-item flex-rowc" @click="handleShowAddressPopup(6)">
            <p>
              {{
                serviceObjectOrganAreaname ? serviceObjectOrganAreaname : "区域"
              }}
            </p>
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="common-list-wrap">
          <div
            class="common-list"
            v-if="serviceObjectOrganList.length > 0 && !organLoading"
          >
            <div
              class="common-item flex-rowl"
              v-for="(item, index) in serviceObjectOrganList"
              :key="index"
              @click="handleSelectServiceOrgan(item)"
              :class="{ active: item.is_selected }"
            >
              <div class="address--bule-icon"></div>
              <div class="item-info-content">
                <div class="item-info-name">
                  {{ item.svname }}
                </div>
                <div class="item-info-text">
                  {{ item.provincestr }}{{ item.citystr }}{{ item.areastr
                  }}{{ item.addr }}
                </div>
                <div class="item-info-operation flex-rowr">
                  <div class="operation-btn">选用</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 加载提示 -->
          <div class="common-loading-wrap flex-rowc" v-if="organLoading">
            <van-loading type="spinner" vertical>加载中...</van-loading>
          </div>
          <div
            class="common-no-data flex-rowc"
            v-if="serviceObjectOrganList.length == 0 && !organLoading"
          >
            <van-empty description="暂无数据" />
          </div>
        </div>
        <div
          class="popup-btn-wrap flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleSubmitServiceOrgan"
        >
          确认
        </div>
      </div>
      <!-- 合作机构 -->
      <div
        class="custom-popup-content custom-popup-content--cooperation"
        v-if="displayModule == 4"
      >
        <div class="search-wrap flex-rowl">
          <span class="search-icon" @click="handleSearch"
            ><img src="../../../assets/images/search-icon.png" alt=""
          /></span>
          <input
            type="text"
            placeholder="请输入关键词"
            v-model="cooperationOrgParams.keyword"
            @keyup.enter="handleSearch"
          />
        </div>
        <div class="common-list-wrap">
          <div
            class="common-list"
            ref="CooperationOrgList"
            @scroll="handleScroll"
            v-if="cooperationOrgList.length > 0 && !cooperationOrgLoading"
          >
            <div
              class="common-item flex-rowl"
              v-for="(item, index) in cooperationOrgList"
              :key="index"
              @click="handleSelectCooperationOrg(item)"
            >
              <div class="media">
                <span
                  class="radio flex-rowc"
                  :class="{ active: item.is_selected }"
                ></span>
                <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="
                    item.logo
                      ? item.logo
                      : require('../../../assets/images/default_avatar.jpg')
                  "
                >
                  <template v-slot:error>
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="
                        require('../../../assets/images/default_avatar.jpg')
                      "
                    ></van-image>
                  </template>
                </van-image>
              </div>
              <div class="content">
                <div class="name">
                  {{ item.insname }}
                </div>
                <div class="txt">
                  <p class="flex-rowl">
                    {{ item.tel }}
                    <a :href="`tel:${item.tel}`" class="tel-icon"></a>
                  </p>

                  <!-- <p>{{ item.user.sex }}，{{ item.user.age }}岁</p> -->
                  <!-- <p>好评率 98%</p> -->
                </div>
                <!-- <div class="tag flex-rowc">
                <span class="icon"></span>1级护理资质
              </div> -->
              </div>
            </div>
          </div>
          <!-- 加载提示 -->
          <div
            class="common-loading-wrap flex-rowc"
            v-if="cooperationOrgLoading"
          >
            <van-loading type="spinner" vertical>加载中...</van-loading>
          </div>
          <div
            class="common-no-data flex-rowc"
            v-if="cooperationOrgList.length == 0 && !cooperationOrgLoading"
          >
            <van-empty description="暂无数据" />
          </div>
        </div>

        <div
          class="popup-btn-wrap flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleConfirmCooperationOrg"
        >
          确认
        </div>
      </div>
    </CustomPopup>

    <!-- 其它费用审核 -->
    <CustomPopup
      :visible="isShowExtraChargePopup"
      position="bottom"
      @close="closeExtraChargePopup"
    >
      <div class="order-popup-content extra-charge-popup-content">
        <div class="tit">
          {{
            extraChargeType == 1
              ? "待审核的追加收费项"
              : extraChargeType == 2
              ? "待审核的额外交通费用项"
              : "待审核的其他额外费用项"
          }}
        </div>
        <div class="popup-main">
          <div class="radio-wrap">
            <div
              class="radio-item flex-rowl"
              :class="{ selected: extraChargeCheck == 1 }"
              @click="extraChargeCheck = 1"
            >
              <span></span>
              <p>审核通过</p>
            </div>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: extraChargeCheck == 2 }"
              @click="extraChargeCheck = 2"
            >
              <span></span>
              <p>审核不通过</p>
            </div>
          </div>
          <div class="pic-list flex-rowl">
            <div
              class="pic-item"
              v-for="(item, index) in tempPicList"
              :key="index"
              @click="previewImage(index, tempPicList)"
            >
              <van-image width="100%" height="100%" fit="cover" :src="item" />
            </div>
          </div>
        </div>
        <div
          class="popup-query-btn flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleExtraCharge"
        >
          确认
        </div>
      </div>
    </CustomPopup>

    <!-- 用户取消订单、退款管理处理 -->
    <CustomPopup :visible="isShowPopup" position="center" @close="closePopup">
      <div class="order-popup-content" v-if="customerPopupType == 1">
        <div class="tit">
          <h1>用户取消订单的原因</h1>
          <p>{{ detail.cancelreasonstr }}</p>
        </div>
        <div class="popup-main calcel-order-popup-main">
          <div class="radio-wrap">
            <p class="txt">客服处理：</p>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: customerServiceType == 1 }"
              @click="customerServiceType = 1"
            >
              <span></span>
              <p>与用户协商成功，继续服务</p>
            </div>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: customerServiceType == 2 }"
              @click="customerServiceType = 2"
            >
              <span></span>
              <p>确认同意取消本次服务</p>
            </div>
          </div>
        </div>
        <div
          class="popup-query-btn flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleCancelOrder"
        >
          确认
        </div>
      </div>
      <div class="order-popup-content" v-else-if="customerPopupType == 2">
        <div class="tit">退款管理</div>
        <div class="price"><span>¥</span>{{ detail.timeoutprice }}</div>
        <div class="popup-main refund-popup-main">
          <p class="sub_tit">
            支付方式：{{
              detail.ispaystr
                ? detail.paytype == 1
                  ? detail.paytypestr
                  : detail.paytypestr +
                    "，" +
                    (detail.getmancardno ? "已确认" : "待确认")
                : ""
            }}
          </p>
          <div class="radio-wrap">
            <div
              class="radio-item flex-rowl"
              :class="{ selected: refundParams.returntype == 1 }"
              @click="refundParams.returntype = 1"
            >
              <span></span>
              <p>全额退款</p>
            </div>
            <div
              class="radio-item flex-rowl"
              :class="{ selected: refundParams.returntype == 2 }"
              @click="refundParams.returntype = 2"
            >
              <span></span>
              <p>部分退款</p>
            </div>
            <div class="radio-item-input">
              <input
                type="number"
                placeholder="输入退款金额"
                v-model="refundParams.refund_amount"
              />
            </div>
          </div>
        </div>
        <div
          class="popup-query-btn flex-rowc"
          :class="{ disabled: isSubmitting }"
          @click="handleRefundOrder"
        >
          确认
        </div>
      </div>
    </CustomPopup>

    <!-- 图片预览 -->
    <ImagePreviewComponent
      v-if="showPreviewComponent"
      :images="previewImages"
      :initialIndex="previewIndex"
      @close="closePreview"
    />
  </div>
</template>
  
  <script>
import Clipboard from "clipboard";
import {
  getCommunityServiceOrderDetail,
  editCommunityServiceOrder,
  addDispatch,
  getFunctionList,
  getCooperationOrgList,
  getUserAddressList,
  addUserAddress,
  getServiceList,
  getEquipmentList,
  editTimeoutCharge,
  editExtraTransportationCharge,
  editOtherExtraCharge,
} from "../../../api/api";
import {
  getProvince,
  getCity,
  getArea,
  submitRefund,
} from "../../../api/public";
import CustomPopup from "../../../components/CustomPopup.vue";
import Decimal from "decimal.js";
import { mapState } from "vuex";
import ImagePreviewComponent from "../../../components/ImagePreviewComponent.vue";

export default {
  name: "OrderDetail",
  components: {
    CustomPopup,
    ImagePreviewComponent,
  },
  data() {
    return {
      // 图片预览
      showPreviewComponent: false,
      previewImages: [],
      previewIndex: 0,

      isShow: false,
      popupType: 1, // 1-器具 2-时长 3-意外险
      // 器具列表
      columnMeachine: [],
      meachinePrice: 0, // 器具费用
      // 时长列表
      columnDuration: [
        {
          text: "1小时",
          value: "1",
        },
        {
          text: "2小时",
          value: "2",
        },
        {
          text: "3小时",
          value: "3",
        },
        {
          text: "4小时",
          value: "4",
        },
        {
          text: "5小时",
          value: "5",
        },
        {
          text: "6小时",
          value: "6",
        },
        {
          text: "7小时",
          value: "7",
        },
        {
          text: "8小时",
          value: "8",
        },
        {
          text: "9小时",
          value: "9",
        },
        {
          text: "10小时",
          value: "10",
        },
      ],
      // 意外险列表
      columnInsurance: [
        {
          text: "需要",
          value: "1",
        },
        {
          text: "不需要",
          value: "0",
        },
      ],
      // 服务人员数量列表
      columnNum: [
        {
          text: "1人",
          value: "1",
        },
        {
          text: "2人",
          value: "2",
        },
        {
          text: "3人",
          value: "3",
        },
        {
          text: "4人",
          value: "4",
        },
        {
          text: "5人",
          value: "5",
        },
        {
          text: "6人",
          value: "6",
        },
        {
          text: "7人",
          value: "7",
        },
        {
          text: "8人",
          value: "8",
        },
        {
          text: "9人",
          value: "9",
        },
        {
          text: "10人",
          value: "10",
        },
      ],

      isShowCustomPopup: false,
      popupPosition: "bottom", // 可以设置为 'center' 或 'bottom'

      displayModule: "", // 控制显示模块，1-陪护人员，2-选择上门服务，3-服务地点，4-合作机构
      isAddAddress: false, // 是否新增服务用户地址

      // 其它费用
      isShowExtraChargePopup: false,
      extraChargeCheck: "", // 1-通过、2-不通过
      extraChargeType: "", // 1-超时费用对象、2-额外交通费用对象、3-其他额外费用对象
      tempPicList: [],

      // 超时费用对象
      timeoutChargeObj: {},
      // 额外交通费用对象
      extraChargeObj: {},
      // 其他额外费用对象
      otherExtraChargeObj: {},

      isShowPopup: false, // 是否显示弹窗
      customerPopupType: "", // 1-取消订单、2-退款管理
      // 客服处理类型
      customerServiceType: "", // 1-与用户协商成功，继续服务、2-确认同意取消本次服务
      // 退款参数
      refundParams: {
        isreturn: 1, // 是否退款 =1=是|0=否|
        refund_amount: "", // 退款金额
        returntype: "", // 申请退款类型 =1=全额退款|2=部分退款|
        returncheck: 0,
      },

      detail: {},
      isLoading: true, // 是否正在加载

      isRefresh: false, // 是否正在刷新

      // 所住楼栋是否有电梯？
      elevatorList: [
        { value: "1", text: "有电梯" },
        { value: "0", text: "无电梯" },
      ],
      // 服务地址参数
      addressParams: {
        topic: "",
        province: "24",
        city: "456",
        area: "",
        addr: "",
        levelfloor: "",
        isElevator: "",
        isuse: 1, // 是否启用 =1=是|0=否|
      },
      provinceList: [],
      cityList: [],
      areaname: "",
      areaList: [],

      // 服务对象到达机构参数
      serviceObjectOrgan: {
        pageindex: 1,
        pagesize: 40,
        keyword: "",
        province: "",
        city: "",
        area: "",
      },
      serviceObjectOrganProvincename: "",
      serviceObjectOrganCityname: "",
      serviceObjectOrganAreaname: "",
      // 服务对象到达机构列表
      serviceObjectOrganList: [],
      organLoading: true,

      // 服务机构参数
      serviceOrganParams: {
        needinaddr: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        isneedin: 0, // 是否需要前往指定服务场所 =1=是|0=否|
      },

      // 上门服务相关参数
      serviceFormData: {
        isgetsend: "", // 是否需要上门接送 =1=我需要上门接送|0=在服务地点接我|
        getsendaddr: "",
        province2: "",
        city2: "",
        area2: "",
        addr2: "",
      },
      addressList: [],
      addressLoading: true, // 是否正在加载

      id: "", // 服务订单id
      formData: {
        service_order_status: 2, // 服务订单状态 =1=待接单|2=已接单，待付款|3=已接单，已付款|4=服务中|5=服务已完成（待评价）|6=服务已完成（已评价）|7=服务取消审核中|8=服务已取消|
        meachinestate: "", // 服务附加设备器具状态
        duration: 1, // 订单服务时长，默认1小时
        mannum: "", // 订单业务员人数
        isinsurance: 0, // 是否需要安全意外险 =1=需要|0=不需要|
        timeoutprice: "", // （manprice * duration * mannum）+ 意外险金额（15）+ 服务附加设备器具金额
        totype: "", // 派单类型 =1=派单给陪护服务合作机构|2= 派单给小铃铛陪护员|
      },

      // 职能分配参数
      dispatchParams: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        role: 1, // 职能身份 =1=陪护员|2=业务主管|
        parkid: "",
      },
      dispatchList: [],
      dispatchTotal: 0,
      isDispatchLoading: true, // 是否正在加载
      isDispatch: false, // 是否派发

      // 合作机构参数
      cooperationOrgParams: {
        pageindex: 1,
        pagesize: 20,
        keyword: "",
        inssate: "1", // 合作状态 =1=启用|0=停用|
      },
      cooperationOrgList: [],
      cooperationOrgLoading: true, // 是否正在加载

      // 临时储存派发人员列表
      tempDispatchList: [],

      isSubmitting: false, // 是否正在提交
    };
  },
  computed: {
    ...mapState(["USERINFO"]),
  },
  async mounted() {
    this.id = this.$route.query.id;
    this.getEquipmentList();
    this.getCommunityServiceOrderDetail();
  },
  methods: {
    // 格式化时间
    formatTime(fieldName) {
      if (fieldName) {
        // 替换 T 为空格
        return fieldName.replace("T", " ");
      }
      return "";
    },

    // 获取订单详情
    async getCommunityServiceOrderDetail() {
      try {
        const res = await getCommunityServiceOrderDetail(this.id);
        this.detail = res;
        // 超时费用
        this.timeoutChargeObj =
          res.park_catering_service_order_fee.length > 0
            ? res.park_catering_service_order_fee[0]
            : {};
        // 额外交通费用
        this.extraChargeObj =
          res.park_catering_service_order_feetraffic.length > 0
            ? res.park_catering_service_order_feetraffic[0]
            : {};
        // 其他额外费用
        this.otherExtraChargeObj =
          res.park_catering_service_order_feeother.length > 0
            ? res.park_catering_service_order_feeother[0]
            : {};
        // 上门服务相关参数
        this.serviceFormData.isgetsend = res.isgetsend;
        this.serviceFormData.getsendaddr = res.getsendaddr;
        this.serviceFormData.province2 = res.province2;
        this.serviceFormData.city2 = res.city2;
        this.serviceFormData.area2 = res.area2;
        this.serviceFormData.addr2 = res.addr2;

        this.formData.meachinestate = res.meachinestate;
        this.meachinestatestr = res.meachinestatestr
          ? res.meachinestatestr
          : res.park_catering_service_order_get.length > 0
          ? "不需要附加器具"
          : "(如需要请选择)";
        this.formData.duration = res.duration ? res.duration : 1;
        this.formData.mannum = res.mannum;
        this.formData.isinsurance = res.isinsurance;
        this.formData.totype = res.totype ? res.totype : "";
        this.tempDispatchList = res.park_catering_service_order_get.map(
          (item) => {
            const { bell_institution, ...rest } = item;
            const firstBellInstitution = bell_institution[0] || {};
            return {
              ...rest,
              insname: firstBellInstitution.insname,
              mobile: firstBellInstitution.mobile,
              tel: firstBellInstitution.tel,
              logo: firstBellInstitution.logo,
            };
          }
        );
        this.isDispatch =
          res.park_catering_service_order_get.length > 0 ||
          res.service_order_status > 6;
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isLoading = false;
      }
    },

    // 获取设备列表
    async getEquipmentList() {
      try {
        let params = {
          pageindex: 1,
          pagesize: 20,
          isuse: 1,
        };
        const res = await getEquipmentList(params);
        let newObj = res.list.map((item) => ({
          value: item.id,
          text: item.meachinename,
          price: item.price,
        }));
        this.columnMeachine = [
          { value: "", text: "不需要附加器具", price: "" },
          ...newObj,
        ];
      } catch (error) {
        console.error("获取街道列表失败", error);
      }
    },

    // 获取职能分配列表
    async getFunctionList() {
      try {
        const res = await getFunctionList(this.dispatchParams);
        if (res.list) {
          this.dispatchList = this.dispatchList.concat(res.list);
          this.dispatchTotal = res.total;
          // 调用更新选中状态的方法
          this.updateSelectedStatus();
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.isDispatchLoading = false;
      }
    },

    // 陪护合作机构管理
    async getCooperationOrgList() {
      try {
        const res = await getCooperationOrgList(this.cooperationOrgParams);
        if (res.list) {
          this.cooperationOrgList = this.cooperationOrgList.concat(res.list);
          this.cooperationOrgTotal = res.total;
          // 调用更新选中状态的方法
          this.updateSelectedStatus();
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.cooperationOrgLoading = false;
      }
    },

    // 获取服务用户地址
    async getUserAddressList() {
      try {
        let dataForm = {
          pageindex: 1,
          pagesize: 20,
          archivesid: this.detail.park_catering_service_order_obj.id,
          isuse: 1,
        };
        const res = await getUserAddressList(dataForm);
        if (res.list) {
          this.addressList = res.list;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.addressLoading = false;
      }
    },

    // 新增服务用户地址
    async addUserAddress() {
      try {
        let dataForm = {
          ...this.addressParams,
          archivesid: this.detail.park_catering_service_order_obj.id,
        };
        const res = await addUserAddress(dataForm);
        if (res.result == "true") {
          this.$toast.success(res.message);
          // 等待 800 毫秒后关闭加载提示
          await new Promise((resolve) => setTimeout(resolve, 800));
          this.isSubmitting = false;
          this.isAddAddress = false;
          this.addressLoading = true;
          this.getUserAddressList();
        } else {
          this.$toast("新增失败");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("获取街道列表失败", error);
        this.$toast("新增失败");
        this.isSubmitting = false;
      }
    },

    // 获取机构名称
    async getServiceList() {
      try {
        let res = await getServiceList(this.serviceObjectOrgan);
        this.serviceObjectOrganList = res.list;
      } catch (error) {
        console.error("获取推荐内容失败:", error);
      } finally {
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.organLoading = false;
      }
    },

    // 1、获取省市
    async getProvince() {
      let res = await getProvince();
      // 使用 map 方法遍历数组，创建新对象并重新设置属性名
      let newObj = res.map((item) => ({
        value: item.areaid,
        text: item.areaname,
      }));
      this.provinceList = [{ value: "", text: "省/直辖市" }, ...newObj];
      this.isShow = true;
    },

    // 2、获取市
    async getCity() {
      let { displayModule } = this;
      let province;
      if (displayModule == 2) {
        province = this.serviceObjectAddress.province;
      } else if (displayModule == 3) {
        province = this.serviceObjectOrgan.province;
      }

      if (!province) {
        this.$toast("请选择省/直辖市");
        return;
      }
      let res = await getCity(province);
      // 使用 map 方法遍历数组，创建新对象并重新设置属性名
      let newObj = res.map((item) => ({
        value: item.cityid,
        text: item.cityname,
      }));
      this.cityList = [{ value: "", text: "城市" }, ...newObj];
      this.isShow = true;
    },
    // 3、获取区
    async getArea() {
      let { displayModule } = this;
      let city;
      if (displayModule == 2) {
        city = this.addressParams.city;
      } else if (displayModule == 3) {
        city = this.serviceObjectOrgan.city;
      }

      if (!city) {
        this.$toast("请选择城市");
        return;
      }
      let res = await getArea(city);
      // 使用 map 方法遍历数组，创建新对象并重新设置属性名
      let newObj = res.map((item) => ({
        value: item.addrid,
        text: item.addrname,
      }));
      this.areaList = [{ value: "", text: "区域" }, ...newObj];
      this.isShow = true;
    },

    // 触发派单类型
    handleDispatchTypeChange() {
      // 清空选择的数据
      this.tempDispatchList = [];
    },

    // 确认弹窗
    async handleSubmit() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      // 校验
      // if (!this.formData.meachinestate) {
      //   this.$toast("请选择附加器具");
      //   return;
      // }
      // if (!this.formData.duration) {
      //   this.$toast("请选择服务时长");
      //   return;
      // }
      // if (!this.formData.isinsurance) {
      //   this.$toast("请选择是否需要安全意外险");
      //   return;
      // }

      if (!this.formData.mannum) {
        this.$toast("请选择服务人员数量");
        return;
      }

      if (!this.formData.totype) {
        this.$toast("请选择派单类型");
        return;
      }

      // 校验派发人员列表
      if (this.tempDispatchList.length == 0) {
        this.$toast(
          this.formData.totype == 1 ? "请添加服务合作机构" : "请添加陪护人员"
        );
        return;
      }
      if (!this.formData.isinsurance && this.formData.isinsurance != 0) {
        this.formData.isinsurance = 0;
      }

      /**
       * 第一步：更新陪护服务订单表数据
       * 第二步：向派单管理子表中新增数据，通过遍历派发人员列表，新增派发人员数据
       */

      // 标记为正在提交
      this.isSubmitting = true;

      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      this.editCommunityServiceOrder();
    },

    // 第一步：更新陪护服务订单表数据
    async editCommunityServiceOrder() {
      try {
        let {
          tempDispatchList,
          detail,
          displayModule,
          id,
          formData,
          serviceFormData,
          serviceOrganParams,
        } = this;
        let { totype } = this.formData;
        let params = {
          // 根据 displayModule 的值合并不同对象
          ...(displayModule == 2
            ? serviceFormData
            : displayModule == 3
            ? serviceOrganParams
            : formData),
          id,
        };
        let res = await editCommunityServiceOrder(params);
        if (res.result) {
          if (displayModule == 2 || displayModule == 3) {
            // 等待 800 毫秒后关闭加载提示
            await new Promise((resolve) => setTimeout(resolve, 500));
            this.closeCustomPopup();
            this.$toast.success(res.message);
            this.isSubmitting = false;
            // 第二步：获取订单详情
            this.getCommunityServiceOrderDetail();
          } else {
            // 重构向派单管理提交的数组
            let dispatchList = tempDispatchList.map((item) => {
              if (totype == 2) {
                return {
                  order_id: detail.order_id,
                  get_staff_name: item.truename
                    ? item.truename
                    : item.user.truename,
                  get_staff_id: item.dispatch_staff_id,
                  get_staff_contact: item.employee_mobile,
                  isdel: 0, // 是否作废 =0=正常|1=已作废|
                  ischarge: 1, // ischarge
                  totype: totype,
                };
              } else if (totype == 1) {
                return {
                  order_id: detail.order_id,
                  get_staff_name: item.insname,
                  get_staff_id: item.hrcode,
                  get_staff_contact: item.mobile,
                  insid: item.id,
                  isdel: 0, // 是否作废 =0=正常|1=已作废|
                  ischarge: 1, // ischarge
                  totype: totype,
                };
              }
              return {};
            });
            // 等待 800 毫秒后关闭加载提示
            await new Promise((resolve) => setTimeout(resolve, 500));
            // 第二步：向派单管理子表中新增数据，通过遍历派发人员列表，新增派发人员数据
            this.addDispatch(dispatchList);
          }
        } else {
          this.$toast.fail("更新失败");
          this.isSubmitting = false;
        }
      } catch (error) {
        console.error("更新失败", error);
        this.$toast.fail("更新失败");
        this.isSubmitting = false;
      }
    },

    // 第二步：向派单管理子表中新增数据，通过遍历派发人员列表，新增派发人员数据
    async addDispatch(dispatchList) {
      let successCount = 0;
      let failedCount = 0;

      for (let i = 0; i < dispatchList.length; i++) {
        try {
          const res = await addDispatch(dispatchList[i]);
          if (res.result) {
            successCount++;
          } else {
            failedCount++;
          }
        } catch (error) {
          console.error("派单失败", error);
          failedCount++;
        }
      }

      if (failedCount === 0) {
        this.$toast.success("派单成功");
        this.scrollToTop();
        // 第二步：获取订单详情
        this.getCommunityServiceOrderDetail();
      } else if (successCount === 0) {
        this.$toast.fail("派单失败");
      } else {
        this.$toast({
          message: `部分派单成功，成功 ${successCount} 条，失败 ${failedCount} 条`,
          type: "fail",
        });
      }
    },

    // 处理派发人员选择
    handleSelect(item) {
      // 仅切换当前选中的派发人员的选中状态
      item.is_selected = !item.is_selected;
      // 强制更新组件，确保页面渲染最新状态
      this.$forceUpdate();

      this.handleConfirm();
    },

    // 处理合作机构选择
    handleSelectCooperationOrg(item) {
      // 仅切换当前选中的派发人员的选中状态
      item.is_selected = !item.is_selected;
      // 强制更新组件，确保页面渲染最新状态
      this.$forceUpdate();

      this.handleConfirmCooperationOrg();
    },

    // 新增方法：更新选中状态
    updateSelectedStatus() {
      if (this.formData.totype == 2) {
        this.dispatchList.forEach((item) => {
          // 判断 tempDispatchList 中是否存在相同 id 的项
          item.is_selected = this.tempDispatchList.some(
            (tempItem) => tempItem.id === item.id
          );
        });
      } else {
        this.cooperationOrgList.forEach((item) => {
          // 判断 tempDispatchList 中是否存在相同 id 的项
          item.is_selected = this.tempDispatchList.some(
            (tempItem) => tempItem.id === item.id
          );
        });
      }
      // 移除排序逻辑，保持数据原有顺序
    },

    // 删除已选中的派发人员
    handleDel(item) {
      this.tempDispatchList = this.tempDispatchList.filter(
        (tempItem) => tempItem.id !== item.id
      );
      // 重新计算服务总费用
      // this.calculateServiceFee();
      item.is_selected = false;
    },

    // 确认派发
    async handleConfirm() {
      // 过滤出 dispatchList 中 is_selected 为 true 的项
      const selectedItems = this.dispatchList.filter(
        (item) => item.is_selected
      );
      if (selectedItems.length == 0) {
        this.$toast("请选择派单人员");
        return;
      }

      // 遍历选中的项，根据唯一标识（如 id）避免重复添加到 tempDispatchList
      selectedItems.forEach((selectedItem) => {
        if (
          !this.tempDispatchList.some((item) => item.id === selectedItem.id)
        ) {
          selectedItem.get_staff_name = selectedItem.truename
            ? selectedItem.truename
            : selectedItem.user.truename;
          this.tempDispatchList.push(selectedItem);
        }
      });

      // 遍历 dispatchList 中 is_selected 为 false 的项，将 tempDispatchList 中对应的数据移除
      this.dispatchList
        .filter((item) => !item.is_selected)
        .forEach((unselectedItem) => {
          this.tempDispatchList = this.tempDispatchList.filter(
            (item) => item.id !== unselectedItem.id
          );
        });

      // 重新计算服务总费用
      // this.calculateServiceFee();

      // 关闭自定义弹窗
      this.closeCustomPopup();
    },

    // 确认合作机构
    async handleConfirmCooperationOrg() {
      // 过滤出 dispatchList 中 is_selected 为 true 的项
      const selectedItems = this.cooperationOrgList.filter(
        (item) => item.is_selected
      );
      if (selectedItems.length == 0) {
        this.$toast("请选择合作机构");
        return;
      }

      // 遍历选中的项，根据唯一标识（如 id）避免重复添加到 tempDispatchList
      selectedItems.forEach((selectedItem) => {
        if (
          !this.tempDispatchList.some((item) => item.id === selectedItem.id)
        ) {
          this.tempDispatchList.push(selectedItem);
        }
      });

      // 遍历 dispatchList 中 is_selected 为 false 的项，将 tempDispatchList 中对应的数据移除
      this.dispatchList
        .filter((item) => !item.is_selected)
        .forEach((unselectedItem) => {
          this.tempDispatchList = this.tempDispatchList.filter(
            (item) => item.id !== unselectedItem.id
          );
        });

      // 重新计算服务总费用
      // this.calculateServiceFee();

      // 关闭自定义弹窗
      this.closeCustomPopup();
    },

    // 下拉刷新
    async onRefresh() {
      // 等待 800 毫秒后关闭加载提示
      await new Promise((resolve) => setTimeout(resolve, 500));
      this.isRefresh = false;
      this.getCommunityServiceOrderDetail();
    },

    // 搜索
    handleSearch() {
      let { displayModule } = this;
      if (displayModule == 1) {
        this.isDispatchLoading = true;
        this.dispatchParams.pageindex = 1;
        this.dispatchList = [];
        this.getFunctionList();
      } else if (displayModule == 3) {
        this.organLoading = true;
        this.getServiceList();
      } else if (displayModule == 4) {
        this.cooperationOrgLoading = true;
        this.cooperationOrgParams.pageindex = 1;
        this.cooperationOrgList = [];
        this.getCooperationOrgList();
      }
    },

    /**
     * 服务收费金额核算
     * @param {number} serviceprice 服务单价
     * @param {number} formData.duration 服务时长（小时）
     * @param {number} formData.mannum 陪护人员数量
     * @param {number} isinsurance 是否需要意外险，1-需要，0-不需要
     * @param {string|number} meachinePrice 服务附加设备器具费用
     * @returns {number} 服务总费用
     */
    calculateServiceFee() {
      let { formData, detail, meachinePrice } = this;
      // 确保 serviceprice、duration 和 mannum 为有效的数字类型
      const serviceprice = Number(detail.serviceprice) || 0;
      const serviceDuration = Number(formData.duration) || 1;
      const manNum = Number(formData.mannum) || 1;

      // gettype 计费模式 =1=按服务时长及服务人员数量收费|2=按单次服务收费|
      let escortFee = 0;
      if (detail.gettype == 1) {
        // 主要服务项目收费 = 服务单价 * 服务时长（小时） * 陪护人员数量
        escortFee = Decimal(serviceprice)
          .mul(serviceDuration)
          .mul(manNum)
          .toNumber();
      } else {
        // 主要服务项目收费 = 服务单价
        escortFee = Decimal(serviceprice).toNumber();
      }

      // 计算意外险费用
      const insuranceFee = formData.isinsurance == 1 ? 15 : 0;
      // 计算服务附加设备器具费用
      const equipmentFee = meachinePrice || 0;

      let totalPrice = Decimal(escortFee ? escortFee : 0)
        .add(Decimal(insuranceFee ? insuranceFee : 0))
        .add(Decimal(equipmentFee ? equipmentFee : 0))
        .toNumber();

      this.detail.timeoutprice = totalPrice;
      this.formData.timeoutprice = totalPrice;
      this.formData.manprice = escortFee;
    },

    /**
     * 是否上门服务操作
     * @param {*} type 0=在服务地点接我 1=我需要上门接送
     */
    handleSelectSend(type) {
      this.serviceFormData.getsendaddr = "";
      this.serviceFormData.province2 = "";
      this.serviceFormData.city2 = "";
      this.serviceFormData.area2 = "";
      this.serviceFormData.addr2 = "";
      this.serviceFormData.isgetsend = type;
    },
    handleSelectAddress(item) {
      this.serviceFormData.getsendaddr = item.topic;
      this.serviceFormData.province2 = item.province;
      this.serviceFormData.city2 = item.city;
      this.serviceFormData.area2 = item.area;
      this.serviceFormData.addr2 = item.addr;

      // 切换点击项的选中状态
      const isSelected = !item.is_selected;
      // 使用 $set 确保 Vue 能检测到属性变化
      this.$set(item, "is_selected", isSelected);

      // 若切换为选中状态，则取消其他项的选中状态
      if (isSelected) {
        this.addressList.forEach((addressItem) => {
          if (addressItem.id !== item.id) {
            this.$set(addressItem, "is_selected", false);
          }
        });
      }
    },
    // 修改上门接送数据
    handleSubmitGetsend() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      let { isgetsend } = this.serviceFormData;
      // 判断this.addressList中是否有选中项
      let selectedAddress = this.addressList.find((item) => item.is_selected);
      if (isgetsend == 1) {
        if (!selectedAddress) {
          this.$toast("请选择上门地址");
          return;
        }
      }
      // 标记为正在提交
      this.isSubmitting = true;

      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      this.editCommunityServiceOrder();
    },
    // 新增服务地址
    async addServiceAddress() {
      this.isAddAddress = true;
    },

    handleSubmitAddress() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return;
      let { topic, area, addr, levelfloor, isElevator } = this.addressParams;
      if (!topic) {
        this.$toast("请输入地址名称");
        return;
      }
      if (!area) {
        this.$toast("请输入选择区域");
        return;
      }
      if (!addr) {
        this.$toast("请输入详细地址");
        return;
      }
      if (!levelfloor) {
        this.$toast("请输入楼层");
        return;
      }
      if (!isElevator) {
        this.$toast("请选择所住楼栋是否有电梯");
        return;
      }

      // 标记为正在提交
      this.isSubmitting = true;
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      this.addUserAddress();
    },
    handleShowAddressPopup(type) {
      if (type == 4) {
        this.getProvince();
      } else if (type == 5) {
        this.getCity();
      } else if (type == 6) {
        this.getArea();
      }
      this.popupType = type;
    },
    handleChangeRadio(item) {
      this.addressParams.isElevator = item.value;
    },
    /**
     *
     */

    /**
     * 服务地点相关处理事件
     */
    handleSelectServiceOrgan(item) {
      this.serviceOrganParams.needinaddr = item.svname;
      this.serviceOrganParams.province = item.province;
      this.serviceOrganParams.city = item.city;
      this.serviceOrganParams.area = item.area;
      this.serviceOrganParams.addr = item.addr;

      // 切换点击项的选中状态
      const isSelected = !item.is_selected;
      // 使用 $set 确保 Vue 能检测到属性变化
      this.$set(item, "is_selected", isSelected);

      // 若切换为选中状态，则取消其他项的选中状态
      if (isSelected) {
        this.serviceObjectOrganList.forEach((addressItem) => {
          if (addressItem.id !== item.id) {
            this.$set(addressItem, "is_selected", false);
          }
        });
      }
    },

    handleSubmitServiceOrgan() {
      // 如果正在提交，直接返回
      if (this.isSubmitting) return;

      let { isgetsend } = this.serviceFormData;
      // 判断this.serviceObjectOrganList中是否有选中项
      let selectedAddress = this.serviceObjectOrganList.find(
        (item) => item.is_selected
      );
      if (isgetsend == 1) {
        if (!selectedAddress) {
          this.$toast("请选择服务机构");
          return;
        }
      }

      // 标记为正在提交
      this.isSubmitting = true;

      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      this.editCommunityServiceOrder();
    },
    handleAddServiceOrgan() {
      this.$router.push({ name: "EditCooperationManagement" });
    },
    /**
     *
     */

    /**
     * 用户订单-支付 管理
     */
    // 提取服务订单状态计算逻辑为独立函数
    calculateServiceOrderStatus(customerServiceType, currentOrder) {
      if (customerServiceType == 2) {
        return {
          service_order_status: 8,
        };
      }
      if (currentOrder.ispay == 1) {
        return {
          service_order_status: 4,
          iscancel: 0,
          cancelreason: "",
        };
      }
      return {
        service_order_status:
          currentOrder.park_catering_service_order_get.length == 0 ? 1 : 2,
        iscancel: 0,
        cancelreason: "",
      };
    },
    // 用户订单取消管理
    async handleCancelOrder() {
      const { customerServiceType, detail } = this;

      if (!customerServiceType) {
        this.$toast("请选择客服处理");
        return;
      }

      // 标记为正在提交
      this.isSubmitting = true;

      const loadingToast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      try {
        const result = this.calculateServiceOrderStatus(
          customerServiceType,
          detail
        );
        await this.editCommunityServiceOrderState(result);
      } catch (error) {
        console.error("用户订单取消管理失败:", error);
      } finally {
        loadingToast.clear(); // 关闭加载提示
        this.isSubmitting = false;
      }
    },
    // 退款管理
    async handleRefundOrder() {
      let { refund_amount, returntype } = this.refundParams;
      if (!returntype) {
        this.$toast("请选择退款类型");
        return;
      }
      if (returntype == 2 && !refund_amount) {
        this.$toast("请输入退款金额");
        return;
      }

      // 如果为全部退款，则退款金额为订单金额
      if (returntype == 1) {
        this.refundParams.refund_amount = this.detail.timeoutprice;
      }

      // 标记为正在提交
      this.isSubmitting = true;

      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "提交中...",
      });

      // 判断订单支付方式
      if (this.detail.paytype == 1) {
        await this.submitRefund();
      } else {
        this.editCommunityServiceOrderState(this.refundParams);
      }
    },
    // 线上支付退费申请
    async submitRefund() {
      try {
        let params = {
          orderid: this.detail.service_order_id,
          truename: this.USERINFO.truename,
          logtype: 1008, // 1008=健康服务订单退款
          reasonid: 10, // 退费原因 从接口64获取id
          returnnote: 1,
          returnattr: 6,
          fee: this.refundParams.refund_amount,
        };
        let res = await submitRefund(params);
        if (!res.result) {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.editCommunityServiceOrderState(this.refundParams);
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },
    // 修改陪护服务订单
    async editCommunityServiceOrderState(data) {
      try {
        let params = {
          ...data,
          id: this.detail.id,
        };
        let res = await editCommunityServiceOrder(params);
        if (!res.result) {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        // 获取服务订单
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.success(res.message);
        this.isShowPopup = false;
        this.isSubmitting = false;
        this.getCommunityServiceOrderDetail();
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
        this.isShowPopup = false;
      }
    },
    /**
     * 用户订单-支付 管理
     */

    /**
     * 额外费用处理
     */
    // 触发按钮
    handleExtraCharge() {
      if (this.isSubmitting) return;

      let { extraChargeType, extraChargeCheck } = this;
      if (!extraChargeCheck) {
        this.$toast("请选择审核类型");
        return;
      }

      this.isSubmitting = true;

      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });

      if (extraChargeType == 1) {
        this.editTimeoutCharge();
      } else if (extraChargeType == 2) {
        this.editExtraTransportationCharge();
      } else if (extraChargeType == 3) {
        this.editOtherExtraCharge();
      }
    },
    // 修改超时追加费用
    async editTimeoutCharge() {
      try {
        let params = {
          id: this.timeoutChargeObj.id,
          checkstate: this.extraChargeCheck,
          order_id: this.detail.order_id,
        };
        let res = await editTimeoutCharge(params);
        if (res.result != "true") {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.success("修改成功");
        this.isSubmitting = false;
        this.closeExtraChargePopup();
        // 第二步：获取订单详情
        await this.getCommunityServiceOrderDetail();
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },
    // 修改额外交通费用
    async editExtraTransportationCharge() {
      try {
        let params = {
          id: this.extraChargeObj.id,
          checkstate: this.extraChargeCheck,
          order_id: this.detail.order_id,
        };
        let res = await editExtraTransportationCharge(params);
        if (res.result != "true") {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.success("修改成功");
        this.isSubmitting = false;
        this.closeExtraChargePopup();
        // 第二步：获取订单详情
        await this.getCommunityServiceOrderDetail();
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },
    // 修改其他额外费用
    async editOtherExtraCharge() {
      try {
        let params = {
          id: this.otherExtraChargeObj.id,
          checkstate: this.extraChargeCheck,
          order_id: this.detail.order_id,
        };
        let res = await editOtherExtraCharge(params);
        if (res.result != "true") {
          throw new Error(res.message || "提交失败，请稍后重试");
        }
        // 等待 800 毫秒后关闭加载提示
        await new Promise((resolve) => setTimeout(resolve, 500));
        this.$toast.success("修改成功");
        this.isSubmitting = false;
        this.closeExtraChargePopup();
        // 第二步：获取订单详情
        await this.getCommunityServiceOrderDetail();
      } catch (error) {
        this.$toast.fail(error.message || "更新失败");
        this.isSubmitting = false;
      }
    },
    /**
     * 额外费用处理
     */

    // 处理滚动事件
    handleScroll() {
      if (this.formData.totype == 2) {
        // 陪护人员
        const { scrollTop, scrollHeight, clientHeight } = this.$refs.UserList;
        let { dispatchList, dispatchTotal, isDispatchLoading } = this;
        if (isDispatchLoading || dispatchList.length >= dispatchTotal) return;
        // 当滚动到底部 20px 范围内时触发加载
        if (scrollTop + clientHeight >= scrollHeight - 20) {
          // this.hasMore = true;
          this.dispatchParams.pageindex++;
          this.isDispatchLoading = true; // 开始加载，设置锁
          this.getFunctionList().finally(() => {
            this.isDispatchLoading = false; // 加载完成，释放锁
          });
        }
      } else {
        // 合作机构
        const { scrollTop, scrollHeight, clientHeight } =
          this.$refs.CooperationOrgList;
        let { cooperationOrgList, cooperationOrgTotal, cooperationOrgLoading } =
          this;
        if (
          cooperationOrgLoading ||
          cooperationOrgList.length >= cooperationOrgTotal
        )
          return;
        // 当滚动到底部 20px 范围内时触发加载
        if (scrollTop + clientHeight >= scrollHeight - 20) {
          // this.hasMore = true;
          this.cooperationOrgParams.pageindex++;
          this.cooperationOrgLoading = true; // 开始加载，设置锁
          this.getCooperationOrgList().finally(() => {
            this.cooperationOrgLoading = false; // 加载完成，释放锁
          });
        }
      }
    },

    // 显示添加弹窗
    showCustomPopup(position, type) {
      if (type == 1) {
        this.dispatchParams.pageindex = 1;
        this.dispatchParams.keyword = "";
        this.dispatchList = [];
        this.isDispatchLoading = true;
        this.getFunctionList();
      } else if (type == 2) {
        this.addressLoading = true;
        this.getUserAddressList();
      } else if (type == 3) {
        this.organLoading = true;
        this.getServiceList();
      } else if (type == 4) {
        this.cooperationOrgParams.pageindex = 1;
        this.cooperationOrgParams.keyword = "";
        this.cooperationOrgList = [];
        this.cooperationOrgLoading = true;
        this.getCooperationOrgList();
      }
      this.popupPosition = position;
      this.displayModule = type;
      this.isShowCustomPopup = true;
    },
    closeCustomPopup() {
      if (this.displayModule == 2 && this.isAddAddress) {
        this.isAddAddress = false;
        return;
      }
      this.isShowCustomPopup = false;
    },

    // 显示费用管理弹窗
    showExtraChargePopup(type, dataObj) {
      if(dataObj.checkstate == 1) return
      if (type == 2) {
        this.tempPicList = [dataObj.pic1, dataObj.pic2, dataObj.pic3].filter(
          (pic) => pic
        );
      } else {
        this.tempPicList = [];
      }
      this.extraChargeCheck = "";
      this.extraChargeType = type;
      this.isShowExtraChargePopup = true;
    },
    closeExtraChargePopup() {
      this.isShowExtraChargePopup = false;
    },

    // 显示弹窗
    handleShowManagePopup(type) {
      if (type == 1) {
        this.customerServiceType = "";
      } else {
        this.refundParams.returntype = "";
      }
      this.customerPopupType = type;
      this.isShowPopup = true;
      this.isSubmitting = false;
    },
    // 关闭弹窗
    closePopup() {
      this.isShowPopup = false;
    },

    // 显示弹窗
    handleShowPopup(type) {
      if (this.isDispatch) {
        return;
      }
      this.popupType = type;
      this.isShow = true;
    },
    onConfirm(e) {
      let { text, value, price } = e;
      let { popupType, displayModule } = this;
      if (popupType == 1) {
        this.formData.meachinestate = value;
        this.meachinestatestr = text;
        this.meachinePrice = price;
        this.calculateServiceFee();
      } else if (popupType == 2) {
        this.formData.duration = value;
        this.detail.duration = value;
        console.log(this.formData.duration);
        this.calculateServiceFee();
      } else if (popupType == 3) {
        this.formData.isinsurance = value;
        this.detail.isinsurance = value;
        this.calculateServiceFee();
      } else if (popupType == 4) {
        if (displayModule == 3) {
          this.organLoading = true;
          this.serviceObjectOrgan.province = value;
          this.serviceObjectOrganProvincename = text;
          this.serviceObjectOrgan.city = "";
          this.serviceObjectOrganCityname = "";
          this.serviceObjectOrgan.area = "";
          this.serviceObjectOrganAreaname = "";
          this.getServiceList();
        }
      } else if (popupType == 5) {
        if (displayModule == 3) {
          this.serviceObjectOrgan.city = value;
          this.serviceObjectOrganCityname = text;
          this.serviceObjectOrgan.area = "";
          this.serviceObjectOrganAreaname = "";
        }
      } else if (popupType == 6) {
        if (displayModule == 2) {
          this.addressParams.area = value;
          this.areaname = text;
        } else if (displayModule == 3) {
          this.serviceObjectOrgan.area = value;
          this.serviceObjectOrganAreaname = text;
        }
      } else if (popupType == 7) {
        this.formData.mannum = value;
        this.calculateServiceFee();
      }
      this.isShow = false;
    },
    onCancel() {
      this.isShow = false;
    },
    handleReturn() {
      this.$router.back();
    },
    // 滚动到顶部
    scrollToTop() {
      const mainWrap = this.$refs.mainWrap;
      if (mainWrap) {
        if ("scrollBehavior" in document.documentElement.style) {
          mainWrap.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          mainWrap.scrollTop = 0;
        }
      }
    },

    // 预览图片
    previewImage(index, images) {
      this.showPreviewComponent = true;
      this.previewImages = images;
      this.previewIndex = index;
    },
    // 关闭图片预览
    closePreview() {
      this.showPreviewComponent = false;
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy-icon");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
  
  <style lang="less">
.order-detail-page {
}
</style>